{
  "analysis": {
    "analysis_help_title": "Wie benutzt man die Tools",
    "analysis_help_description": "Verwenden Sie die Zeichenwerkzeuge, um eine Linie oder einen Bereich auf der Karte zu zeichnen. Wenn Sie ein Objekt ausgewählt haben, erweitern Sie die folgenden Abschnitte, um verschiedene Analysetypen anzuzeigen."
  },
  "sidebarToolbar": {
    "delete_layer": "Ebene löschen",
    "remove_layer": "Ebene entfernen"
  },
  "sidebarLayers": {
    "emptyLayer": "{{ layerName }} hat noch keine Objekte",
    "emptyGroup": "{{ groupName }} hat keine Ebenen oder Gruppen"
  },
  "attributes": {
    "namingOrder": "Reihenfolge der Benennungen",
    "customerIdentifier": "Name der Kunden-ID",
    "list_items": {
      "add_another_placeholder": "Fügen Sie eine weitere Listenoption hinzu",
      "add_first_placeholder": "Fügen Sie eine Listenoption hinzu"
    },
    "dataDriven": {
      "canDo": "Attributgesteuertes Styling",
      "noDatafields": "Fügen Sie Attribute hinzu, um den attributgesteuerten Stil zu verwenden",
      "label": "Mithilfe von Attributen festlegen",
      "tour": {
        "stage_one": {
          "title": "Attributgesteuertes Styling",
          "content": "Sie müssen ein Listenattribut hinzufügen, bevor Sie Ihren Layer anhand von Attributwerten stylen können"
        }
      }
    },
    "predefined_subtitle": "Wählen Sie aus einer Reihe von vorgefertigten Attributen",
    "custom_subtitle": "Erstellen Sie Ihr eigenes Attribut, z. B. eine benutzerdefinierte Liste oder ein Texteingabefeld",
    "attribute_type": "Typ des Attributs",
    "create_new_attribute": "Erstellen Sie ein neues Attribut, indem Sie einen Typ aus der folgenden Liste auswählen und ihn nach Ihren Anforderungen bearbeiten",
    "edit_attribute": "Bearbeiten Sie dieses Attribut, indem Sie einen Typ aus der folgenden Liste auswählen und ihn an Ihre Anforderungen anpassen",
    "edit_attribute_no_type": "Bearbeiten Sie dieses Attribut mithilfe der folgenden Felder und passen Sie es an Ihre Anforderungen an",
    "create_attribute_title": "Attribut erstellen",
    "edit_attribute_title": "Attribut bearbeiten",
    "add_attribute_subtitle": "Fügen Sie ein neues Attribut hinzu, indem Sie entweder ein vordefiniertes auswählen oder ein völlig neues erstellen",
    "predefined_info_title": "Vordefinierte Attribute",
    "predefined_info_text": "Projektadministratoren können diese in den Projekteinstellungen verwalten",
    "predefined_info_link": "Klicken Sie hier, um zu den „Projekteinstellungen“ zu gelangen",
    "create_predefined_title": "Erstellen Sie ein vordefiniertes Attribut"
  },
  "styles": {
    "fill": "Füllen"
  },
  "layer_tour": {
    "tip_1_welcome": {
      "title": "Passe deine Ebene an",
      "content": "Sie können ändern, wie Ihre Ebene aussieht und welche Informationen (Attribute) Sie speichern möchten, wenn Sie dem Plan Objekte hinzufügen."
    },
    "tip_2_name": {
      "title": "Name der Ebene",
      "content": "Ändere den Namen deiner Ebene, um besser zu beschreiben, was du dem Plan hinzufügst"
    },
    "tip_3_attributes": {
      "title": "Attribute",
      "content": "Fügen Sie Attribute hinzu (optional), um Informationen über Objekte im Plan zu speichern. Sie können beispielsweise Typen/Kategorien, Kosten, Mengen, Daten oder alles andere, was Sie benötigen, erfassen."
    },
    "tip_4_styles": {
      "title": "Stile",
      "content": "Ändern Sie, wie Objekte in dieser Ebene auf dem Plan aussehen, z. B. Farben und Größen."
    },
    "tip_5_attribute_styles": {
      "title": "Attributbasiertes Styling",
      "content": "Verwenden Sie Attribute, um zu bestimmen, wie Objekte aussehen. Beispielsweise könnten verschiedene „Typen/Kategorien“ unterschiedliche Farben haben."
    },
    "tip_6_save": {
      "title": "Speichern",
      "content": "Wenn Sie fertig sind, drücken Sie auf Speichern, um die Ebene zum Plan hinzuzufügen. Sie können diese Einstellungen später jederzeit ändern, z. B. weitere Attribute hinzufügen oder den Stil anpassen."
    }
  },
  "formula_summary": {
    "remove_formula": "Formel entfernen"
  },
  "layer_information": {
    "title": "Informationen zur Ebene",
    "owner_map_location": "Der Besitzer plant den Standort",
    "open_in_folder": "Im Ordner öffnen",
    "created_by": "Erstellt von",
    "created_on": "Erstellt am",
    "last_modified": "Zuletzt geändert",
    "permissions": "Genehmigungen",
    "view_collaborators": "Mitwirkende anzeigen und bearbeiten",
    "visualiser_overflow": "... {{ nodeCount }} weitere Ordner",
    "edit_style": "Ebenen-Einstellungen"
  },
  "edit_layer": {
    "add_to_map": "Zum Plan hinzufügen",
    "customise": "Vorlage anpassen",
    "text_position": "Position des Textes",
    "text_offset": "Text-Offset"
  },
  "style_errors": {
    "invalid_incrementor_value": "Ungültiger Wert. Bitte geben Sie einen Wert zwischen {{ minValue }} und {{ maxValue }} ein"
  },
  "style": {
    "error": "Etwas ist schief gelaufen, die Ebenenänderungen wurden nicht gespeichert"
  },
  "toolbarButtonTooltips": {
    "confirm_action": "Vollständige Zeichnung"
  }
}